import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid
} from '@mui/material/'
import { useNavigate } from 'react-router-dom'
import { removeInviteHashLocalStorage } from '../utils/localStorage'
import { LaakariButton } from './styled/uiComponents'

interface Props {
  open: boolean
  handleClose: () => void
}

const FrontPageConfirmation: React.FC<Props> = ({ open, handleClose }) => {
  const navigate = useNavigate()

  const handleNavigateFrontpage = () => {
    removeInviteHashLocalStorage()
    navigate('/')
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <Grid container>
        <Grid item xs={12}>
          <DialogTitle>{'Haluatko palata etusivulle?'}</DialogTitle>
        </Grid>
        <Grid item xs={12}>
          <DialogContent>
            <DialogContentText>Oletko varma, että haluat palata etusivulle?</DialogContentText>
          </DialogContent>
        </Grid>
        <Grid item xs={12}>
          <DialogActions>
            <Grid container item justifyContent='space-between' direction='row'>
              <Grid item xs={5}>
                <LaakariButton onClick={handleClose}>Ei</LaakariButton>
              </Grid>
              <Grid item xs={5} sx={{ textAlign: 'right' }}>
                <LaakariButton variant='outlined' onClick={handleNavigateFrontpage} autoFocus>
                  Kyllä
                </LaakariButton>
              </Grid>
            </Grid>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default FrontPageConfirmation
